import { select } from "gamedata/GameData";
import { Map } from "~/components/ui/Map";
import { PageTitle } from "~/components/ui/PageTitle";
import { tt, useT } from "~/util/Lang";
import { $LOADER, $PAGE } from "~/util/Loaders";
import { gameName } from "~/util/common";
import { logPageView } from "~/util/stats";
import { homePage } from "~/util/titles";

$PAGE({
  path: "map/teleports",
  loader: $LOADER?.(async (la) => {
    // Log
    logPageView(la);
    //
    const t = tt.bind(null, la.realm.lang);

    const teleporters = Array.from(la.gd.npcs.values()).filter(
      (npc) =>
        npc.teleports.length > 0 &&
        npc.spawns.length > 0 &&
        !npc.npcName.includes("adventurer_agent") &&
        !npc.npcName.includes("event_teleporter")
    );

    return {
      authUser: la.req.sess?.user,
      teleporters: select(teleporters, {
        select: {
          spawns: {
            select: { pos: { select: { x: true, y: true } } },
          },
          teleports: {
            select: { select: { name: t, x: true, y: true, price: true } },
          },
        },
      }),
    };
  }),
  meta: (cx) => {
    return {
      title:
        cx.t({ en: "Raid Bosses Map", ru: "Карта рейд боссов" }) +
        " - " +
        homePage(cx.realm),
      description: cx.t({
        en: `${gameName(cx.realm.game)} Raid Bosses Map`,
        ru: `Карта рейд боссов ${gameName(cx.realm.game)}`,
      }),
      ogTitle: `Lineage 2 Raid Bosses Map`,
    };
  },
  render: ({ data }) => {
    const t = useT();
    const mapTitle = t({ en: "Teleports Map", ru: "Карта телепортов" });

    const teleports: Array<{
      from: { x: number; y: number };
      to: { x: number; y: number };
    }> = [];
    console.log("DATA", data);
    for (const npc of data.teleporters) {
      const pos = npc.spawns[0].pos[0];
      const from = { x: pos.x, y: pos.y };
      for (const tpGroup of npc.teleports) {
        if (
          tpGroup.every((tp) => tp.price === 1) ||
          tpGroup.every((tp) => tp.price === 1000)
        ) {
          continue;
        }
        for (const tp of tpGroup) {
          if (tp.price === 0) {
            continue;
          }
          const to = { x: tp.x, y: tp.y };
          teleports.push({ from, to });
        }
      }
    }

    return (
      <div className="content">
        <PageTitle>{mapTitle}</PageTitle>

        <Map fullscreen teleports={teleports} />
      </div>
    );
  },
});
